import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { colors } from 'styles';

export default function DatePickerMaterialUI({
  value,
  onDateChange,
  bgColor = colors.back36,
  disablePast = true,
  minDate = null,
  maxDate = null,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        value={value}
        onChange={onDateChange}
        disablePast={disablePast}
        slotProps={{
          textField: {
            helperText: 'MM/DD/YYYY',
          },
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: bgColor,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
        minDate={minDate}
        maxDate={maxDate}
      />
    </LocalizationProvider>
  );
}
